// @flow
import React, { Component } from 'react';

import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import { grey100 } from 'material-ui/styles/colors';

import AvLibraryBook from 'material-ui/svg-icons/av/library-books';
import GeometryFormatSelectField from 'components/GeometryFormatSelectField';

import FeatureToggle from 'components/FeatureToggle';
import { parseFeature, serializeFeature } from 'utils/geometry';

const styles = {
  container: {
    padding: '0 16px 16px',
  },
  buttonContainer: {
    textAlign: 'right',
  },
  textField: {
    background: grey100,
    borderRadius: 2,
    padding: 6,
    marginBottom: 10,
  },
  copySourceTextarea: {
    opacity: 0.01,
    height: 0,
    position: 'absolute',
    zIndex: -1,
  },
};

export default class GeometryTextField extends Component {
  state = {
    geometryText: '',
  };

  async _setGeometryText(props) {
    this.setState({
      geometryText: await serializeFeature(
        await parseFeature(props.search.geometry_text, 'notam'),
        props.geometryFormat
      ),
    });
  }

  componentDidMount() {
    this._setGeometryText(this.props);
  }

  async componentWillReceiveProps(nextProps) {
    this._setGeometryText(nextProps);
  }

  copyToClipboard = e => {
    this.textArea.select();
    document.execCommand('copy');
    e.target.focus();
    this.props.showErrorMessage('Koordináták a vágólapra másolva.', {
      severity: 'INFO',
    });
  };

  render() {
    return (
      <div style={styles.container}>
        <FeatureToggle flag="hasSubscription">
          <GeometryFormatSelectField
            geometryFormat={this.props.geometryFormat}
            setGeometryFormat={this.props.setGeometryFormat}
            allowAutodetect={false}
          />
        </FeatureToggle>

        <TextField
          floatingLabelText="Koordináták listája"
          rows={10}
          textareaStyle={styles.textField}
          value={this.state.geometryText}
          underlineShow={false}
          multiLine
          fullWidth
          readOnly
        />

        <textarea
          ref={textarea => {
            this.textArea = textarea;
          }}
          style={styles.copySourceTextarea}
          value={this.state.geometryText}
        />
        <div style={styles.buttonContainer}>
          <FlatButton
            label="Másolás a vágólapra"
            icon={<AvLibraryBook />}
            primary
            onClick={this.copyToClipboard}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/SearchResultsDialog/GeometryTextField.js